<template>
  <div>
   <Navbar />
    <v-container fluid class="pa-0">
      <v-row>
        <v-col cols="12">
          <Rahbariyat />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Navbar from '../components/navbar.vue';
import Rahbariyat from './Rahbariyat.vue';

export default {
  name: "AdminPanel",
  components: { Navbar,Rahbariyat },
}
</script>

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
</style>